import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Dialog,
  Stack,
  Typography
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { useTranslation } from "react-i18next";
import {
  DeleteProfileImageModalContentBox, StyledError
} from "./DeleteProfileImageModal.styles";
import { DeleteProfileImageModalProps } from "./DeleteProfileImageModal.types";

import {
  ButtonText,
  Icon,
  Spinner
} from "..";
import { TitleTypography } from "../../components/CalendarCard/CalendarCard.style";
import { useDeleteProfileImageQuery } from "../../queries";

export function DeleteProfileImageModal({
  closeDrawer,
  onSuccess,
  onClose,
  open,
  ...props
}: DeleteProfileImageModalProps) {
  const { t } = useTranslation();
  const theme = useTheme();

  const {
    mutate: deleteProfileImage,
    isSuccess:deleteProfileImageSuccess,
    isLoading:deleteProfileImageLoading,
    error: deleteProfileImageError,
    isError: deleteProfileImageIsError,
    isIdle: deleteProfileImageIdle,
    reset: deleteProfileImageReset
  } = useDeleteProfileImageQuery();

  const onCloseDrawer = () => {
    closeDrawer();
    setTimeout(() => {
      deleteProfileImageReset();
    }, 300);
  };

  return (
    <>

      <Dialog
        maxWidth={ false }
        open={ open }
        onClose={ onClose }
        scroll={ "paper" }
        sx={ {
          ".MuiDialog-paper ": {
            background: theme.linearGradients.gradientB,
            borderRadius:"8px",
            maxHeight:"calc(100% - 32px)",
            padding: "10px"
          }
        } }
      >

        <DeleteProfileImageModalContentBox
          container
          { ...props }
        >

          { deleteProfileImageLoading && <Spinner/> }
          { deleteProfileImageIsError && (
            <Stack gap={ "24px" }>
              <TitleTypography sx={ { fontSize: "20px" } }>{ t("error_occurred") }</TitleTypography>
              { typeof deleteProfileImageError === "string" && deleteProfileImageError != "" && (
                <Accordion>
                  <AccordionSummary
                    expandIcon={ <Icon icon={ "dropdown" }/> }
                    aria-controls="deleteProfileImageErrorContent"
                    id="deleteProfileImageErrorHeader"
                  >
                    <Typography component="span">{ t("error_details") }</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <StyledError>{ deleteProfileImageError }</StyledError>
                  </AccordionDetails>
                </Accordion>
              ) }
              <Box alignSelf={ "center" }>
                <ButtonText onClick={ onCloseDrawer }
                >
                  { t("close") }
                </ButtonText>
              </Box>
            </Stack>
          ) }
          { deleteProfileImageSuccess && (
            <Stack flexDirection={ "column" } gap={ "24px" }>
              <Stack
                alignItems={ "center" }
                flexDirection={ "column" }
                gap={ 3 }>
                <Icon
                  color={ theme.customColors.accentVariantB }
                  icon="Icons_modulo-completato"
                  size={ 45 }
                />
                <Typography sx={ { textAlign: "center" } }>{ t("profile_delete_avatar_success") }</Typography>
              </Stack>
              <Box alignSelf={ "center" }>
                <ButtonText onClick={ () => {
                  onCloseDrawer();
                  onSuccess();
                } }
                >
                  { t("close") }
                </ButtonText>
              </Box>
            </Stack>
          ) }

          { deleteProfileImageIdle && !deleteProfileImageError && (
            <Stack gap={ "24px" }>
              <Typography
                sx={ {
                  fontSize: "20px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "24px",
                  textAlign: "center"
                } }
              >{ t("profile_delete_avatar_message") }
              </Typography>
              <Stack
                direction={ "row" }
                justifyContent={ "center" }
                gap={ "24px" }>
                <ButtonText onClick={ () =>{
                  deleteProfileImage();
                } }
                >
                  { t("yes") }
                </ButtonText>
                <ButtonText variant={ "outlined" } onClick={ onCloseDrawer }>
                  { t("no") }
                </ButtonText>
              </Stack>
            </Stack>
          ) }

        </DeleteProfileImageModalContentBox>
      </Dialog>
    </>
  );

}
